import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
// const querystring = require('querystring');
const localizer = momentLocalizer(moment)


export default class JournalView extends Component {


	constructor(props)
	{
		console.log(props);
		super(props);
				let parms = "";
// 				JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state={
			events: [
      		{
        		start: moment().toDate(),
        		end: moment()
          			.add(7, "days")
          			.toDate(),
        		title: "My Journal Events"
      		}
    		],
			journal : {
					"journalsId": JSON.parse(parms).id,
				  "journalName": "",
				  "ownerUserId": 0,
				  "projectId": 0,
				  "desktopId": 0,
				  "contentId": 0,
				  "securityContextId": 0,
				  "journalStatusCode": 0,
				  "journalDescr": "",
				  "journalEntry": "",
				  "journalAlertFlag": true,
				  "journalReminderFlag": true,
				  "journalAttachments": "",
				  "journalParticipants": "",
				  "journalEntryDate": new Date(),
				  "effectiveDate": new Date(),
				  "expirationDate": new Date(),
				  "createUser": 0,
				  "createDate": new Date(),
				  "lastUpdateUser": 0,
				  "lastUpdateDate": new Date()
				  }
		}
		this.handleClear = this.handleClear.bind(this);
		this.handleOnLoad = this.handleOnLoad.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		
		
	}


	handleClear(){
		this.setState({journal : {}});
		this.setState({journals : []});
		this.setState({events: {}});
	 }
	 componentDidMount() 
	 {
	 	this.handleOnLoad();
	 }
// 	Event {
//   title: string,
//   start: Date,
//   end: Date,
//   allDay?: boolean
//   resource?: any,
// }

handleOnLoad = () => {
	axios.get(`${global.config.apiServicesUrl}/vlm-journals?filter[where][createUser][eq]=${this.props.userId}`).then(res => {
  	const journals = res.data;
  	console.log(journals);
  	
  	this.setState({ journals : res.data });

	//create events for all the journal objects
	
	const journalEvents = journals.map(journal => {
		 let cevent = {
			title : journal.journalName,
			start : journal.effectiveDate,
			end : journal.expirationDate, 
			allDay : false,
			resource : journal.journalId
		};
		console.log(cevent);
		return cevent;
		});
	this.setState({events : journalEvents});
	});
	
	
				 
// 					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.journal.createUserId}`)
// 					.then(response =>{
//  					this.setState({createUserName : response.data});
// 					}).catch(function (error) {
// 						console.log("Error:"+error);
// 					});		
// 					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.journal.lastUpdateUserId}`)
// 					.then(response =>{
//  					this.setState({lastUpdateUserName : response.data});
// 					}).catch(function (error) {
// 					console.log("Error:"+error);
// 					});		
}

	 handleDelete(event){
	 	event.preventDefault();
 	 	//alert(`deleting posting with id = ${this.state.blog.blogId}`);
		axios.delete(`${global.config.apiServicesUrl}/blogs/${this.state.journal.journalId}`).then(res => {
  		this.handleClear();
		window.location.href = "/journals";
  		});
  	}
  		
  			
	render(){
    return (
        	<div class="m-content">			
        				

        					
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       			<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<Link to="/" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</Link>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<Link to="/" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</Link>
									</li>
								</ul>
							</div>
							<a class="btn btn-primary" href="/journals">List View</a>&nbsp;
							<a class="btn btn-success" href="/create-journal">Create Journal Event</a>&nbsp;
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="#" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
		
		<form>
		<div class="container-fluid">
		{/*<h4>Journal Viewer</h4>*/}
		<hr />
		
			<Calendar
		      	localizer={localizer}
		      	defaultView="day"
		      	defaultDate={new Date()}
      			events={this.state.events}
      			startAccessor="start"
      			endAccessor="end"
      			style={{ height: 600 }}
      			selectable="true"
    		/>
			        	
		</div>
		</form>
					</div>
					</div>		            
				</div>		            
		</div>
		</div>
		</div>
	);
}
}